<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import DataFieldForm from '@/components/data-fields/DataFieldForm.vue';
    import { DataField } from '@/types';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        dataField: DataField;
    }>();

    const form = useForm({
        data_field_id: props.dataField.data_field_id,
        data_field_name: props.dataField.data_field_name,
        data_field_status: props.dataField.data_field_status,
        data_field_group: props.dataField.data_field_group,
        data_field_color: props.dataField.data_field_color,
    });
</script>

<template>
    <DialogForm
        type="update"
        method="patch"
        :form="form"
        :route="route('v2.data-fields.update')"
        :query-key="[QueryKey.DATA_FIELDS]"
        title="system.edit_data_field"
    >
        <DataFieldForm :form="form" />
    </DialogForm>
</template>
